import moment from "moment"

/**
 * Админсикй сервис для работы с импортируемыми пользователями
 */
export default class ImportedUserService {
	/**
	 * Инициализировать сервис
	 * @param {Object} httpClient
	 * @param {Object} errorHandler
	 */
	constructor(httpClient, errorHandler) {
		this.httpClient = httpClient
		this.errorHandler = errorHandler
	}

	/**
	 * Расширить модель пользователя
	 * @param {Object} user
	 */
	extendUser(user) {
		const createdAt = moment.unix(user.created_at).format("DD.MM.YYYY HH:mm")

		return { ...user, createdAt }
	}

	/**
	 * Получить импортированных пользователей
	 */
	async getUsers() {
		try {
			const users = await this.httpClient.get("admin/importer/importer-user/list")

			/**
			 * Если 2 (и более) пользователя совпадут по email, то объединять их в одну строку, добавляя:
			 * - объект products (массив) из бэковых product
			 * - ids из бэковых id
			 */
			let normalizedUsers = []
			users.forEach(user => {
				// const existedUserIndex = normalizedUsers.findIndex(normUser => normUser.email == user.email)
				// if (existedUserIndex != -1) {
				// 	normalizedUsers[existedUserIndex].products.push(user.product)
				// 	normalizedUsers[existedUserIndex].ids.push(user.id)
				// } else {
				const newUser = user
				if (!newUser.products) {
					newUser.products = [newUser.product]
				}
				if (!newUser.ids) {
					newUser.ids = [newUser.id]
				}
				normalizedUsers.push(newUser)
				// }
			})

			return normalizedUsers.map(this.extendUser)
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось получить импортированных пользователей")
		}
	}

	/**
	 *
	 * Привязать импортированного пользователя к OOHDESK ID (coreUserId)
	 */
	async linkUser({ importUserId, oohdeskId } = {}) {
		try {
			return await this.httpClient.post("admin/importer/link-to-oohdesk-id", { importer_user_id: importUserId, core_user_id: oohdeskId })
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось привязать OOHDESK ID")
		}
	}

	/**
	 * Создать новый OOHDESK ID из импорт. пользователя и привязать к этому одеск айди импорт. пользователя
	 */
	async createOohdeskId(importUserId) {
		try {
			return await this.httpClient.post("admin/importer/create-oohdesk-id", { importer_user_id: importUserId })
		} catch (error) {
			throw this.errorHandler.handle(error).parse("Не удалось создать OOHDESK ID")
		}
	}
}
